<template>
	<slot v-if="visible"></slot>
</template>

<script>
export default {
	name: 'Tab',
	props: {
		caption: {
			type: String,
			default: null
		},
		visible: {
			type: Boolean,
			default: true
		},
		badge: {
			type: String,
			default: null
		},
		/** Первая такая вкладка уезжает вправо вместе с последующими (доп. разделы) */
		alignRight: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style>
</style>
